const state = () => ({
    mode: 'default',
    user: null,
    medicalCourse: null,
    isAutoReserved: null,
    doctorMenu: null,
    schedule: null,
    questions: null,
    commonQuestions: null,
    matchingQuestions: null,
    paymentMethod: null,
    userCoupon: null,
    timezoneWithCurrentTime: null,
    searchDate: null,
    searchStartTime: null,
    asRepeat: false,
    prevConsultation: null,
})

const mutations = {
    setMode(state, value) {
        state.mode = value
    },
    setUser(state, value) {
        state.user = value
    },
    setMedicalCourse(state, value) {
        state.medicalCourse = value
    },
    setIsAutoReserved(state, value) {
        state.isAutoReserved = value
    },
    setDoctorMenu(state, value) {
        state.doctorMenu = value
    },
    setSchedule(state, value) {
        state.schedule = value
    },
    setQuestions(state, value) {
        state.questions = value
    },
    setCommonQuestions(state, value) {
        state.commonQuestions = value
    },
    setMatchingQuestions(state, value) {
        state.matchingQuestions = value
    },
    setPaymentMethod(state, value) {
        state.paymentMethod = value
    },
    setUserCoupon(state, value) {
        state.userCoupon = value
    },
    setTimezoneWithCurrentTime(state, value) {
        state.timezoneWithCurrentTime = value
    },
    setSearchDate(state, value) {
        state.searchDate = value
    },
    setSearchStartTime(state, value) {
        state.searchStartTime = value
    },
    setAsRepeat(state, value) {
        state.asRepeat = value
    },
    setPrevConsultation(state, value) {
        state.prevConsultation = value
    },
    clearReservation(state) {
        state.mode = 'default'
        state.user = null
        state.medicalCourse = null
        state.isAutoReserved = null
        state.doctorMenu = null
        state.schedule = null
        state.questions = null
        state.commonQuestions = null
        state.matchingQuestions = null
        state.paymentMethod = null
        state.userCoupon = null
        state.timezoneWithCurrentTime = null
        state.searchDate = null
        state.searchStartTime = null
        state.asRepeat = false
        state.prevConsultation = null
    },
}

const getters = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
